import React from 'react';
import { AedContext } from './aed-context';
import { AedStore } from './aed-store';

export function useAedStore(): AedStore {
    const aedStore = React.useContext(AedContext);
    if (!aedStore) {
        throw new Error('Unexpectedly did not find aedStore on context.');
    }
    return aedStore;
}
